import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { isEmpty } from 'lodash-es';

import { ReactComponent as CrossIcon } from '../../../../../assets/images/cross-secondary.svg';
import { ReactComponent as DropzoneIcon } from '../../../../../assets/images/ZipFileIcon.svg';
import BackButton from '../../../../../components/shared/BackButton/BackButton';
import Button from '../../../../../components/shared/Button/Button';
import FileUpload from '../../../../../components/shared/FileUpload/FileUpload';
import { IsMobile } from '../../../../../helpers/IsMobile';
import { importLinkedInContacts } from '../../../../../redux/actions/linkedInImportActions';
import urls from '../../../../../routing/urls';

import styles from './LinkedInImportZip.module.scss';

const LinkedInImportZip = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = IsMobile();
  const [acceptedFiles, setAcceptedFiles] = useState([]);

  const navigateOnSuccess = () => {
    navigate(urls.syncSources);
  };

  const handleSubmit = useCallback(() => {
    const requestData = new FormData();
    requestData.append('linkedin_import_file', acceptedFiles[0]);
    dispatch(importLinkedInContacts(requestData, navigateOnSuccess));
  }, [acceptedFiles]);

  return (
    <div className={styles.rootCont}>
      {!isMobile && (
        <div className={styles.backCont}>
          <BackButton onBack={() => navigate(urls.syncSources)} />
        </div>
      )}
      <div className={styles.sectionCont}>
        <div className={styles.headerTopContainer}>
          <div className={classNames(styles.headingContainer)}>
            <p className={styles.heading}>{t('linkedinNetwork.importLinkedinFile')}</p>
            {isMobile && (
              <div
                className={classNames(styles.closeBtn)}
                role="presentation"
                onClick={() => navigate(urls.syncSources)}
              >
                <CrossIcon />
              </div>
            )}
          </div>
          {isMobile ? (
            <p className={styles.info}>{t('linkedinNetwork.uploadLinkedinFile')}</p>
          ) : (
            <p className={styles.info}>{t('linkedinNetwork.dragDropLinkedinFile')}</p>
          )}
        </div>
        <div className={styles.fileUploadContainer}>
          {isEmpty(acceptedFiles) ? (
            <div className={styles.fileUpload}>
              <FileUpload
                handleOnDrop={(file) => setAcceptedFiles(file)}
                accept={{ 'application/zip': ['.zip'] }}
                DropzoneIcon={DropzoneIcon}
              />
            </div>
          ) : (
            <div className={styles.selectedFile}>
              <span className={styles.fileName}>{acceptedFiles[0].name}</span>
              <div className={styles.deleteBtnContainer}>
                <button type="button" className={styles.deleteBtn} onClick={() => setAcceptedFiles([])}>
                  X
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={styles.actionsCont}>
        <Button className={classNames(styles.btn, styles.cancelBtn)} onClick={() => navigate(urls.syncSources)}>
          {t('cancel')}
        </Button>
        <Button className={styles.btn} onClick={handleSubmit} disabled={isEmpty(acceptedFiles)}>
          {t('save')}
        </Button>
      </div>
    </div>
  );
};

export default LinkedInImportZip;
